import { fromBn } from './utils';

// Mobile wallets the backend can offer (GET /api/site → payment: [{ method, number }]).
// Students Send Money to our personal number, then enter the number they paid from and the TrxID.
export const WALLETS = {
  bkash: { name: 'bKash', color: '#e2136e', ussd: '*247#' },
  nagad: { name: 'Nagad', color: '#ec1c24', ussd: '*167#' },
  rocket: { name: 'Rocket', color: '#8c3494', ussd: '*322#' },
};

// "bKash, Nagad বা Rocket"
export function walletNames(payment) {
  const names = payment.map((p) => WALLETS[p.method].name);
  return names.length > 1 ? `${names.slice(0, -1).join(', ')} বা ${names.at(-1)}` : names[0] || '';
}

// bKash and Nagad accounts are the 11-digit mobile number; Rocket adds a check digit (12 digits).
// Returns the digits or null. Mirrors normalizeWalletNumber in the backend.
export function normalizeWalletNumber(raw, method) {
  const digits = fromBn(raw).replace(/\D/g, '').replace(/^88(?=01)/, '');
  const pattern = method === 'rocket' ? /^01[3-9]\d{8,9}$/ : /^01[3-9]\d{8}$/;
  return pattern.test(digits) ? digits : null;
}

// bKash TrxIDs are 10 characters, Nagad 8, Rocket numeric. Returns the uppercase ID or null.
export function normalizeTrxId(raw) {
  const id = fromBn(raw).replace(/[\s-]/g, '').toUpperCase();
  return /^[A-Z0-9]{6,30}$/.test(id) ? id : null;
}
